import { print } from 'graphql/language/printer';
import { gql } from '@apollo/client';

export const LOGIN = print(gql`
  mutation authenticator($email: String!, $password: String!, $userData: String) {
    authenticator(input: { email: $email, password: $password, userData: $userData }) {
      access_token
    }
  }
`);
